import React from 'react';

import { CollaboratorsPanel } from 'src/components/workflow/workflow-detail/side-panel/CollaboratorsPanel';
import { CommentsPanel } from 'src/components/workflow/workflow-detail/side-panel/CommentsPanel';
import { DocumentsPanel } from 'src/components/workflow/workflow-detail/side-panel/DocumentsPanel';
import { IntakeFormSidePanel } from 'src/components/workflow/workflow-detail/side-panel/IntakeFormSidePanel';
import { PhaseSettingsPanel } from 'src/components/workflow/workflow-detail/side-panel/PhaseSettingsPanel';
import { TaskDetailsPanel } from 'src/components/workflow/workflow-detail/side-panel/TaskDetailsPanel';
import { useSidePanelView } from 'src/components/workflow/workflow-detail/side-panel/use-side-panel-view';
import type { SidePanelState } from 'src/components/workflow/workflow-detail/side-panel/use-side-panel-view';
import { WorkflowChatPanel } from 'src/components/workflow/workflow-detail/side-panel/WorkflowChatPanel';
import { WorkflowSettingsPanel } from 'src/components/workflow/workflow-detail/side-panel/WorkflowSettingsPanel';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
}));

function renderSidePanelContent(state: SidePanelState): JSX.Element {
  switch (state.view) {
    case 'chat':
      return <WorkflowChatPanel />;
    case 'collaborators':
      return <CollaboratorsPanel workflowId={state.workflowId} />;
    case 'comments':
      return <CommentsPanel workflowId={state.workflowId} />;
    case 'documents':
      return <DocumentsPanel workflowId={state.workflowId} />;
    case 'intake':
      return <IntakeFormSidePanel workflowId={state.workflowId} />;
    case 'phase-settings':
      return <PhaseSettingsPanel phaseId={state.phaseId} workflowId={state.workflowId} />;
    case 'task':
      return <TaskDetailsPanel taskId={state.taskId} workflowId={state.workflowId} />;
    case 'workflow-settings':
      return <WorkflowSettingsPanel workflowId={state.workflowId} />;
  }
}

/**
 * Workflow side-panel content for the global right drawer.
 * Renders workflow drawer views (chat, collaborators, comments, documents,
 * etc.) based on the current URL via useSidePanelView().
 */
export function WorkflowSidePanelContent(): JSX.Element {
  const { classes } = useStyles();
  const panelState = useSidePanelView();

  return <div className={classes.root}>{renderSidePanelContent(panelState)}</div>;
}
